import * as React from "react"
import type { IconProps } from "../types"

const Info = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M11 11H12V16M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        />
        <rect 
          fill={color}
          stroke={color}
          x="11.25"
          y="7.25"
          width="1.5"
          height="1.5"
          rx="0.75"
          strokeWidth={0.5}
        />
        <rect
          x="11.25"
          y="7.25"
          width="1.5"
          height="1.5"
          rx="0.75"
          fill={color}
          stroke={color}
          strokeWidth="0.5"
        />
      </svg>
    )
  }
)
Info.displayName = "Info"

export default Info
